export default {"src":"/_next/static/media/academicLogo1.3acec9d4.svg","height":48,"width":159,"blurWidth":0,"blurHeight":0};